import { HeaderLanguageDropdown } from "common/components/Select/languageDropdown";
import { HeaderButtonContainer } from "common/components/Wrapper/headerButton";
import { HEADER_HEIGHT } from "common/const/const";
import { TextTitle4 } from "common/components";
import styled from "styled-components";
import { colors } from "common/const/colors";
import { Settings16Icon } from "common/components/icon";
import { useLocation } from "react-router";
import { useEffect, useRef, useState } from "react";
import { useSse } from "common/hooks/useSse";
import { showMessageModal } from "common/utils/modalController";
import { HeaderNotificationButton } from "./Notification/NotificationButton";

const StyledHeader = styled.header`
  display: flex;
  position: ${({ transparent }) => (transparent ? "fixed" : "sticky")};
  top: 0;
  right: 0;
  width: ${({ transparent }) => (transparent ? "100vw" : "auto")};
  min-height: ${HEADER_HEIGHT};
  background-color: ${({ transparent }) =>
    transparent ? "transparent" : colors.White};
  border-bottom: ${({ transparent }) =>
    transparent ? "none" : `0.5px solid ${colors.Gray}`};
  justify-content: flex-end;
  align-items: center;
  z-index: 900;
  padding: 0 0.75rem;

  box-sizing: border-box;
`;

export const Header = ({ isStatic }) => {
  const location = useLocation(); // 현재 라우트 정보
  const [userName, setUserName] = useState();
  const [popupIdList, setPopupIdList] = useState([]);
  const isProcessing = useRef(false); // 현재 모달이 떠 있는지 체크하는 플래그

  const triggerModal = (id, msg) => {
    isProcessing.current = true;

    showMessageModal(msg, () => {
      isProcessing.current = false;

      setPopupIdList((prev) => {
        return prev.filter((item) => item !== id);
      });
    });
  };

  const { connected } = useSse({
    enabled: !!userName,
    onConnected: (info) => {
      console.log("SSE connected", info);
    },
    onMessage: (data) => {
      console.log("SSE payload", data);
      const popupId = data.id || Date.now();
      const { type, message } = data;

      // 1. 이미 모달이 떠 있다면 리스트에 쌓기만 하고 종료
      if (isProcessing.current) {
        setPopupIdList((prev) => [...prev, popupId]);
        return;
      }

      // 2. 모달이 없다면 실행
      // triggerModal(data.id, "New notification received.");

      if (document.visibilityState !== "visible") {
        if (Notification.permission === "granted") {
          const noti = new Notification("New Notification", {
            body: "New notification received.",
          });
          noti.onclick = () => {
            window.focus(); // 알림 클릭 시 해당 탭으로 이동
            window.dispatchEvent(new CustomEvent("open-notification-panel")); // 알림 패널 열기
          };
        }
      }
    },
    onError: () => {
      console.log("SSE reconnecting...");
    },
  });

  useEffect(() => {
    setUserName(sessionStorage.getItem("userName"));
  }, [location.pathname]);

  return (
    <StyledHeader transparent={!isStatic}>
      {connected && sessionStorage.getItem("clubId") && (
        <HeaderNotificationButton />
      )}
      <HeaderLanguageDropdown showText={!connected} />
      {userName && (
        <HeaderButtonContainer
          onClick={() => (window.location.href = "/profile")}>
          <TextTitle4>{userName}</TextTitle4>
          <Settings16Icon />
        </HeaderButtonContainer>
      )}
    </StyledHeader>
  );
};
